
import lazyload from "@/directives/lazyload";
import Nicole from "@/assets/images/landing/img/Nicole.png";
import Brad from "@/assets/images/landing/img/brad.webp";
import Lucy from "@/assets/images/landing/img/lucy.webp";
import Kelly from "@/assets/images/landing/img/Kelly.png";
import SaraK from "@/assets/images/landing/img/SaraK.png";
import LogoAmerican from "@/assets/images/landing/svg/flag-american.svg";
export default {
  data() {
    return {
      stories: [
        {
          name: "Nicole C.",
          text:
            `I like to think that I’m not a prude. I enjoy PDAs as long as they aren’t vulgar, and I am open to erotic experimentation as long as it isn’t something dangerous. When I met my latest ex he seemed laid back and fun. He made me feel really comfortable so I had no reason to be suspicious, at least that is what I thought. What I learned later though really freaked me out. A friend caught her husband doing virtual hook-ups with live cam girls. I asked her how she found out and she told me about iFindCheaters. At first I felt weird about searching those things to see if he was watching them. Boy, am I glad I did, though! Not only was he a subscriber to <strong>Live Adult Streams</strong>, but he also had an uplink and was streaming our intimate encounters at his place for others to watch! I felt so violated. When I confronted him he told me not to be so “uptight”, that he kept the lights low so no one would recognize me. What an A$$! I kicked him to the curb. But I am a lot more careful now. Watch your backs people!`,
          imgMain: Nicole,
          imgSecond: Brad,
          imgThird: Lucy,
          logo: LogoAmerican,
        },
        {
          name: "Brad P.",
          text:
            `Being a parent of an impressionable teenager is extra challenging in this digital world. With their nose buried in their screens, God knows what they could be up to! A lesson I learned recently in parenting is that we must be proactive in protecting our children from things that they’re too young to be exposed to! On cues from a fellow parent who monitored his daughter’s online activity, I, too, had to intervene when my 14YO son wouldn’t leave his room or even look up from his phone! Using technology to my advantage, I <strong>searched on live adult streams</strong>, an effective tool by iFindCheaters to ensure my fears were not true! Fortunately, they weren’t. But I did find one of my son’s classmates on a couple of adult sites and did my part to alert the parents.`,
          imgMain: Brad,
          imgSecond: Lucy,
          imgThird: Nicole,
          logo: LogoAmerican,
        },
        {
          name: "Lucy H.",
          text:
            `TLDR: If you have a nagging feeling of someone watching you, especially during your intimate moments with your partner, don’t ignore it! I was in an emotionally abusive relationship for over 5 years. The biggest reason and a catalyst that helped break out of it was when I discovered his unsettling obsession with watching live adult streams. He would spend hours holed up in his home-office which I later found out was spent on this “work”. Thanks to an old friend who did a <strong>search on live adult streams</strong> and warned me ahead of time on what he found there. When my ex tried to persuade me to film our personal moments was the breaking point. I deeply thank iFindCheaters!`,
          imgMain: Lucy,
          imgSecond: Nicole,
          imgThird: Brad,
          logo: LogoAmerican,
        },
      ],
      transitionClass: "list-next",
      pageNumber: 0,
    };
  },
  methods: {
    prevPage() {
      this.pageNumber--;
      this.transitionClass = "list-prev";
    },
    nextPage() {
      this.pageNumber++;
      this.transitionClass = "list-next";
    },
  },
  directives: {
    lazyload,
  },
};
